import React from 'react';

function Footer() {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer>
      <div id="go-top">
        <a title="Back to Top" href="#home">
          <i className="fa-solid fa-chevron-up"></i>
        </a>
      </div>
      <p style={{ 
        color: '#8892b0', 
        fontSize: '0.85rem',
        padding: '1rem 0'
      }}>
        © {currentYear} Elisabete Monteiro. All rights reserved.
      </p>
    </footer>
  );
}

export default Footer;
